import { FC, HTMLAttributes } from 'react'
import styled from 'styled-components'

import { ResponsiveImage } from '@syconium/little-miss-figgy'

import { ProductCatalogEmbroideryPlacement } from '../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { deriveNameFromEmbroideryPlacement } from '../../../containers/EmbroideryContainer/utils/deriveNameFromEmbroideryPlacement'
import { useImageLoader } from '../../../lib/hooks/useImageLoader'

import { DetailLine, Visual } from './styles'
import { Template } from './Template'

export type Props = {
  className?: string
  backgroundColor: string | undefined
  imgSrc: string | undefined
  logoName: string | undefined
  logoPlacement: ProductCatalogEmbroideryPlacement | string | undefined
} & HTMLAttributes<HTMLDivElement>

export const B2bLogoSneakPeek: FC<Props> = ({
  className,
  backgroundColor,
  imgSrc,
  logoName,
  logoPlacement,
  ...rest
}) => {
  const { imageLoader } = useImageLoader()
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()
  const logoLabel = fixtures.logoOption.logoLabelLine.replace('{{logoName}}', logoName ?? '')
  const logoPlacementString =
    typeof logoPlacement === 'undefined'
      ? undefined
      : typeof logoPlacement === 'string'
      ? logoPlacement
      : deriveNameFromEmbroideryPlacement(logoPlacement)
  const logoPlacementLabel = logoPlacementString
    ? fixtures.logoOption.logoPlacementLabelLine.replace('{{logoPlacement}}', logoPlacementString)
    : fixtures.logoOption.logoPlacementLabel

  if (!imgSrc) return null
  return (
    <Template.Container data-testid='logo-sneak-peek-container' className={className} {...rest}>
      <Template.Header backgroundColor={backgroundColor}>
        <ImageWrapper>
          <ResponsiveImage
            alt={logoName || 'CustomLogo'}
            aspectRatios={{
              sm: null,
              md: null,
            }}
            src={imageLoader({ src: imgSrc, width: 560, height: 100 })}
            loading={'default'}
            widths={{ unit: 'vw', sm: 100, md: 100 }}
          />
        </ImageWrapper>
      </Template.Header>
      <Template.Body>
        {logoName && <DetailLine $general>{logoLabel}</DetailLine>}
        {logoPlacement && <DetailLine>{logoPlacementLabel}</DetailLine>}
      </Template.Body>
    </Template.Container>
  )
}

const ImageWrapper = styled(Visual)`
  padding: ${o => o.theme.spacing(3.5, 6)};
`
